import {
  BillingTab,
  getBillingPageLink,
  getBillingProductLink,
} from "@redotech/redo-merchant-links/links";
import {
  BILL_DATE_PARAM,
  lastMonthsSelection,
  serializeBillDateSelection,
} from "./bill-date-selection";

/** The Bills page's top-level tab strip, keyed off the same param it writes. */
export const BILLS_TAB_PARAM = "tab";

/** Opens that bill's detail modal on load, so a link can land on Pay now. */
export const BILL_ID_PARAM = "billId";

export const BILLS_PAYMENT_METHODS_TAB = "payment_methods";

// Bills defaults to the last 60 days, too narrow an answer to "what have I been
// charged for this product".
export const PRODUCT_ENTRY_MONTHS = 6;

/**
 * One invoice, opened in its detail modal. The date window is set wide enough
 * to contain the bill so closing the modal does not reveal an empty table.
 */
export function billLink(teamId: string, billId: string, now: Date): string {
  const params = new URLSearchParams({
    [BILL_DATE_PARAM]: serializeBillDateSelection(
      lastMonthsSelection(now, PRODUCT_ENTRY_MONTHS),
    ),
    [BILL_ID_PARAM]: billId,
  });
  return `${getBillingPageLink(teamId, BillingTab.BILLS)}?${params.toString()}`;
}

/** Where "update your billing info" goes: the payment methods tab. */
export function paymentMethodsLink(teamId: string): string {
  return `${getBillingPageLink(teamId, BillingTab.BILLS)}?${BILLS_TAB_PARAM}=${BILLS_PAYMENT_METHODS_TAB}`;
}

/** Settings → Billing with the Returns card open, listing its returns invoices. */
export function returnsBillingLink(teamId: string): string {
  return getBillingProductLink(teamId, BillingTab.RETURNS);
}
